import none from '../../img/kandokLogo.jpg'
export const drink =[
 {
  "id": 61,
  "title": "نوشابه شیشه ای زرد\/مشکی\/سون آپ",
  "price": 0,
  "image": none
 },
 {
  "id": 62,
  "title": "دلستر شیشه ای لیمویی\/استوایی\/مالت",
  "price": 0,
  "image": none
 },
 {
  "id": 63,
  "title": "لیموناد",
  "price": 0,
  "image": none
 },
 {
  "id": 64,
  "title": "دوغ شیشه ای\/ آب معدنی",
  "price": 0,
  "image": none
 }
]